import styled from 'styled-components';
import { Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  gap: ${Spacing.SINGLE};
  text-align: left;
  ${Font.bySize(Font.Size.XXS, Font.Weight.SEMI_BOLD)};
  ${Mixins.Flex.center()}
`;

export const CountContainer = styled.div`
  color: ${Colors.GRAY_DARK_10};
  gap: ${Spacing.HALF};
  text-align: left;
  ${Mixins.Flex.center()}
`;
